import * as React from "react"
import { SVGProps } from "react"
const Logo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={205.997} height={50.939} viewBox="0 0 205.997 50.939" {...props}>
    <g fill="none" fillRule="evenodd">
      <text
        fill="#23272F"
        fontFamily="SourceSansPro-SemiBold, Source Sans Pro"
        fontSize={23.494}
        fontWeight={500}
        letterSpacing={-1.4}
        transform="translate(40 13.939)"
      >
        <tspan x={19.068} y={24.524}>
          tombo
        </tspan>
      </text>
      <text
        fill="#23272F"
        fontFamily="SourceSansPro-SemiBold, Source Sans Pro"
        fontSize={23.494}
        fontWeight={500}
        transform="translate(40 13.939)"
      >
        <tspan x={88.506} y={24.524}>
          ai
        </tspan>
      </text>
      <text
        fill="#FF6D0C"
        fontFamily="SourceSansPro-SemiBold, Source Sans Pro"
        fontSize={9.509}
        fontWeight={500}
        transform="translate(40 13.939)"
      >
        <tspan x={82.304} y={29.293}>
          *
        </tspan>
      </text>
      <text fill="#CC67C4" fontFamily=".AppleSystemUIFont" fontSize={30.318} transform="translate(45 13.939)">
        <tspan x={0} y={29}>
          *
        </tspan>
      </text>
      <g transform="translate(0 .939)">
        <ellipse cx={22.5} cy={48.134} fill="#A4A4A3" rx={22.5} ry={1.866} />
        <path fill="#00819D" stroke="#979797" strokeWidth={0.61} d="M13.73 42.594h5.606v4.365H13.73z" />
        <path
          stroke="#0095A6"
          strokeWidth={1.366}
          d="M13.177 42.537c.073 1.213.508 2.151 1.304 2.816s2.516 1.136 5.16 1.413"
        />
        <path
          stroke="#004F53"
          strokeWidth={1.366}
          d="M12.182 41.791v3.505h1.402v1.221c0 .094.076.17.17.17h1.106v1.323h5.434a.341.341 0 0 0 .341-.342v-.639a.341.341 0 0 0-.341-.341h-.21V41.79h-7.902Z"
        />
        <path
          stroke="#004F53"
          strokeWidth={1.366}
          d="M12.928 42.289c.153 1.743.624 2.946 1.411 3.607.788.662 2.472 1.118 5.053 1.368"
        />
        <path fill="#00819D" stroke="#979797" strokeWidth={0.61} d="M28.783 42.594h-5.606v4.365h5.606z" />
        <path
          stroke="#0095A6"
          strokeWidth={1.366}
          d="M29.337 42.537c-.073 1.213-.508 2.151-1.304 2.816s-2.516 1.136-5.16 1.413"
        />
        <path
          stroke="#004F53"
          strokeWidth={1.366}
          d="M31.326 41.791v3.505h-1.402v1.221a.17.17 0 0 1-.17.17h-1.106v1.323h-5.434a.341.341 0 0 1-.341-.342v-.639c0-.188.153-.341.341-.341h.21V41.79h7.902Z"
        />
        <path
          stroke="#004F53"
          strokeWidth={1.366}
          d="M30.58 42.289c-.153 1.743-.624 2.946-1.411 3.607-.788.662-2.472 1.118-5.053 1.368"
        />
        <path fill="#049E91" d="m19.637 10.199-7.879 1.707-3.802 6.27v22.869h26.577l1.268-5.931v-20.41l-1.268-2.798z" />
        <path fill="#14BAA9" d="m11.685 8.458 2.676 3.482H30.32l1.006-2.857-5.03-.625z" />
        <path
          fill="#FFF"
          d="M30.331 11.9c1.064.547 1.787 1.042 2.17 1.483.383.441.679 1.121.888 2.04h1.915c-.086-1.366-.388-2.45-.905-3.25-.516-.8-1.595-1.872-3.235-3.218L30.33 11.9Z"
        />
        <path
          fill="#088776"
          d="m12.705 8.458 1.964 3.523c-2.311 1.1-3.679 2.245-4.103 3.436-.424 1.191-.522 5.31-.295 12.357h1.434c.608 0 1.159.358 1.405.914l1.008 2.272v10.085l-6.928-.6-.726-26.814c1.038-1.905 1.93-3.167 2.676-3.786.746-.618 1.934-1.08 3.565-1.387Z"
        />
        <path
          stroke="#08625A"
          strokeWidth={1.537}
          d="M14.489 7.96h13.8a7.512 7.512 0 0 1 7.512 7.513v23.01a2.561 2.561 0 0 1-2.56 2.562H9.024a2.561 2.561 0 0 1-2.56-2.561v-22.5a8.025 8.025 0 0 1 8.024-8.024Z"
        />
        <path fill="#0AB7AE" d="M6.215 28.856h2.696l1.282 4.412-.708 2.783-1.773.765-1.217-.225z" />
        <path fill="#39B460" d="m6.215 29.353 1.244 1.442v6.02H6.215z" />
        <path
          fill="#86DC91"
          d="M16.636 12.935H28.38a4.44 4.44 0 0 1 4.439 4.44v8.544c0 .66-.535 1.195-1.195 1.195H12.88c-.66 0-1.195-.535-1.195-1.195v-8.032a4.951 4.951 0 0 1 4.951-4.952Z"
        />
        <path
          fill="#124E2B"
          fillRule="nonzero"
          d="M15.037 22.07c-.153-.021-.195.006-.13.06-.007-.208-.106-.422-.204-.637 0 0-.01.028-.01-.061a8.53 8.53 0 0 0-.024-.4c.267-2.89 1.977-4.14 4.802-3.42.103.017.159.05.223.1.17.092.278.134.386.176 0 0-.022-.026.002.05.18.206.336.335.492.465.165.261.33.522.54.917.107.196.17.258.234.32.01.4.02.798.033 1.391-.03.386-.06.578-.092.77-1.053 2.308-4.872 2.475-6.252.269m3.26-2.344c-.023.833.408 1.37 1.268 1.35.355-.008.989-.436.989-.674 0-.493-.193-1.173-.57-1.436-.643-.449-1.3-.163-1.688.76ZM25.2 18.515c2.118-1.538 3.7-1.47 5.28.23.06.051.098.126.155.206.09.117.121.153.153.189.083.2.165.398.29.775a28.84 28.84 0 0 1-.34 2.376s.008.021-.05.054c-.25.273-.44.513-.63.752 0 0-.004 0-.09.033-.982.272-1.879.511-2.775.75-1.553-.37-2.438-1.356-2.8-3.013l-.028-.741c.154-.363.307-.726.54-1.215.1-.164.12-.203.142-.241.064-.017.111-.054.153-.155m3.413 2.47c.884.396 1.572.157 1.693-.764.054-.406-.33-1.009-.705-1.272-.234-.164-1.135.06-1.187.25-.14.508.018 1.091.199 1.785Z"
        />
        <path
          fill="#DEF5F0"
          fillRule="nonzero"
          d="M18.4 19.5c.37-.797 1.025-1.072 1.667-.64.375.254.569.91.568 1.385 0 .23-.632.642-.986.65-.858.019-1.289-.499-1.249-1.395ZM28.529 20.913c-.112-.619-.273-1.199-.13-1.703.052-.189.97-.41 1.209-.248.381.261.773.86.718 1.263-.123.914-.824 1.152-1.797.688Z"
        />
        <path
          fill="#124E2B"
          fillRule="nonzero"
          d="M23.129 24.615c-.359.284-.756.364-1.061.098-.224-.195-.312-.551-.435-.846-.022-.053.068-.165.129-.23.018-.019.124.016.168.052.679.544.678.545 1.237-.052.38.327.144.64-.038.978Z"
        />
        <path
          fill="#2B7610"
          d="M6.215 28.856v7.692l-1.543 1.014-1.58-1.42-.854-2.933.853-1.887zM36.05 28.856v7.692l1.555 1.014 1.978-.272.927-3.131c.103-1.32-.334-2.51-1.313-3.573-.978-1.063-2.027-1.64-3.147-1.73Z"
        />
        <path fill="#39B460" d="M36.05 27.86h-1.573l-.665 9.205 2.238-.357z" />
        <path fill="#0AB7AE" d="M34.31 27.86h-1.701l-.786 5.339.731 2.752.33 1.114h1.425z" />
        <path
          stroke="#025952"
          strokeLinecap="round"
          strokeWidth={1.366}
          d="m7.44 37.035-.945-.163h0l-1.307.698a1.36 1.36 0 0 1-1.712-.359C2.34 35.763 1.985 34 2.414 31.92c1.137-1.89 2.606-3.028 4.41-3.413a2.732 2.732 0 0 1 3.302 2.737l-.091 3.659a2.22 2.22 0 0 1-2.595 2.132ZM33.946 37.335l2.346-.454h0l1.158.868a1.365 1.365 0 0 0 1.973-.36c1.029-1.625 1.337-3.436.925-5.435-1.59-2.648-3.918-4.01-6.98-4.09a1.024 1.024 0 0 0-1.048 1.028v7.102a1.366 1.366 0 0 0 1.626 1.341Z"
        />
        <path
          stroke="#08625A"
          strokeLinecap="round"
          strokeWidth={1.878}
          d="M20.627 7.463c.07-2.371-.308-3.966-1.132-4.783-.783-.776-2.72-1.171-5.811-1.185a.512.512 0 0 1-.507-.51V0h0"
        />
        <path fill="#FFF" d="M16.16 29.851h13.425v7.96H16.16z" />
        <path fill="#E4C354" d="M18.398 31.343h9.696v1.493h-9.696z" />
        <path fill="#00BAE5" d="M18.398 33.582h9.696v1.493h-9.696z" />
        <path
          fill="#3E7D72"
          fillRule="nonzero"
          d="M20.785 36.46c-.073-.102-.135-.17-.143-.245-.035-.336.06-.615.474-.64.304-.02.537.073.512.442-.026.39-.176.615-.63.534a.752.752 0 0 1-.213-.092Z"
        />
        <path
          fill="#0E8E80"
          fillRule="nonzero"
          d="M27.731 35.572c.244.11.56.194.603.354.047.174-.108.498-.272.607-.127.084-.522.003-.588-.12-.151-.284-.262-.663.257-.84ZM25.362 35.741c.064.226.187.486.103.605-.09.13-.398.208-.563.16-.13-.039-.298-.35-.253-.463.106-.262.299-.55.713-.302Z"
        />
      </g>
    </g>
  </svg>
)
export default Logo
